import React, {useEffect, useState} from 'react'

import styles from '../styles.module.css'

interface Props {
  accessToken: string
  onOrderSelected: (orderId: string) => void
}

const OrdersList: React.FC<Props> = ({accessToken, onOrderSelected}) => {
  const [orders, setOrders] = useState([])

  useEffect(() => {
    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: accessToken
      }
    }

    fetch('https://poc-micro-service.herokuapp.com/orders', requestOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          setOrders(result)
        },
        (error) => {
          console.log(error)
        }
      )
  }, [])

  return (
    <div className={styles.test}>
      <h1>Ordens (Lib react)</h1>
      {orders.map((order: any) => (
        <h5 key={order.uuid}>
          Ordem Nº:{' '}
          <a href='#' onClick={() => onOrderSelected(order.uuid)}>
            {order.number}
          </a>
        </h5>
      ))}
    </div>
  )
}

export default OrdersList
